export default "__VITE_ASSET__CuUZM2$Y__"